import * as types from "../../constants/action-types";

export function requestStarted() {
    return {type : types.SET_REQUEST_STARTED};
}

export function requestEnded() {
    return {type : types.SET_REQUEST_ENDED};
}

export const addPopup = (payload) => {
    return {type : types.SET_CURRENT_POPUP, payload};
}

export const removePopup = (payload) => {
    return {type : types.REMOVE_CURRENT_POPUP, payload};
}

export function setDeviceState(payload) {
    return {type : types.SET_DEVICE_STATE, payload};
}

export const setBurgerState = (payload) => {
    return {type : types.SET_BURGER_STATE, payload};
}
export const setBurgerAnimate = (payload) => {
    return {type : types.SET_BURGER_ANIMATE, payload};
}